<template>
    <div class="single-game-sport" v-if="match">
        <div class="sgame-header" :class="'header-color-' + match.sportId">
            <div class="sgame-header-content">
                <div class="sgame-header-left">
                    <p class="sgame-header-text">{{match.tournamentName}}</p>
                </div>
            </div>
            <p class="sgame-teams">{{match.mn}}</p>
            <p class="sgame-date">{{match.utcDate | getLocalDate}}</p>
        </div>
        <div class="sgame-content">
            <div class="sgame-groups-container" :class="(match.ms == 'block') ? 'is-blocked' : ''">
              <div class="sgame-odds-box" v-for="group in groups" :key="group.bgi">
                  <p class="sgame-odds-header">{{group.bgn}}</p>
                  <div class="sgame-odds-container">
                      <div class="sgame-odds-content">
                        <div class="sgame-odd" v-if="group.odds[0].osbv">
                            <div class="sgame-odd-header">{{$t('OSBVTRANS')}}</div>
                            <div class="sgame-odd-value no-odd sbv">{{group.odds[0].osbv}}</div>
                          </div>
                          <div class="sgame-odd" v-for="odd in group.odds" :key="odd.oi">
                              <div class="sgame-odd-header">{{odd.ot}}</div>
                              <div class="sgame-odd-value odd-result no-odd" :class="odd.os">
                                <span
                                :class="{'striked': ((odd.ovf == '-1' && odd.os == 'win')
                                || odd.os == 'refund')}">{{odd.ov | formatOdd}}</span>
                                <span v-if="odd.os == 'win' && odd.ovf == '-1'" class="refund-odd">1</span>
                                <span v-else-if="odd.os == 'refund'" class="refund-odd">{{odd.ovf | formatOdd}}</span>
                              </div>
                              <!--
                              if($odd['os'] == 'win')
                            {
                                if($odd['ovf'] == '-1')
                                {
                                    $oddValue = '<strike>'.(($odd['ov'] != '') ? \SBWeb\Lib\Common::oddFormat($odd['ov']) : '-').'</strike><span class="yellow bold">1</span>';
                                }
                                else
                                {
                                    $class = 'green bold';
                                    $oddValue = ($odd['ov'] != '') ? \SBWeb\Lib\Common::oddFormat($odd['ov']) : '-';
                                }
                            }

                            if($odd['os'] == 'refund')
                            {
                                $oddValue = '<strike>'.(($odd['ov'] != '') ? \SBWeb\Lib\Common::oddFormat($odd['ov']) : '-').'</strike><span class="yellow bold">'.\SBWeb\Lib\Common::oddFormat($odd['ovf']).'</span>';
                            }

                            if($odd['os'] == 'lost')
                            {
                                $class = 'red';
                            }
                              -->
                          </div>
                      </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'SportSingleResults',
    async created()
    {
        const me = this;

        if (me.isMobile && me.selectedMatch == null)
        {
            me.selectMatch(me.$route.params.matchId);
        }

        me.fetchMatchData();
    },
    props: ['matchesIn'],
    data()
    {
        return { groups: [] };
    },
    methods:
    {
        ...mapActions([
            'selectEvent',
            'selectMatch',
        ]),
        formatOddName(oddNameOut, odd)
        {
            const me = this;

            const { match } = me;

            if (typeof oddNameOut === 'undefined')
            {
                return '';
            }

            let oddName = oddNameOut;

            const nameParams = oddName.split('|');

            const index = 1;
            /*
            switch(trans.lang)
            {
                case '4': //polish
                    index = 4;
                    break;
                case '3': //romanian
                    index = 1;
                    break;
            }
        */

            if (typeof nameParams[index] !== 'undefined' && nameParams[index] !== '')
            {
                oddName = nameParams[index];
            }
            else
            {
                [oddName] = nameParams;
            }

            if (typeof match !== 'undefined')
            {
                const teamNames = match.mn.split('·');
                oddName = oddName
                    .replace(/\{\$competitor1\}/g, teamNames[0])
                    .replace(/\{\$competitor2\}/g, teamNames[1]);

                if (typeof match.mtd !== 'undefined' && typeof match.mtd.tServ !== 'undefined')
                {
                    oddName = oddName.replace('{%server}', teamNames[(parseInt(match.mtd.tServ, 10) - 1)]);
                }
            }

            if (typeof odd !== 'undefined')
            {
                for (const key in odd.spc)
                {
                    if (odd.spc[key] !== undefined)
                    {
                        const spc = odd.spc[key];
                        oddName = oddName.replace(`{${key}}`, spc);
                        oddName = oddName.replace(`{-${key}}`, (-parseFloat(spc)));
                        oddName = oddName.replace(`{+${key}}`, (+parseFloat(spc)));
                        oddName = oddName.replace(`{!${key}}`, `${spc}.`);
                    }
                }
            }

            return oddName;
        },
        generateGroups()
        {
            const me = this;

            if (me.match === undefined || me.match.oddsResults === undefined)
            {
                return;
            }

            const groups = {};
            for (const odd of me.match.oddsResults)
            {
                if (groups[odd.bgi] === undefined)
                {
                    groups[odd.bgi] = {
                        bgi: odd.bgi,
                        sbo: odd.sbo,
                        bgn: me.sportTree.markets[odd.bgi].bgn,
                        odds: {},
                        info: false,
                    };
                }

                odd.ot = me.formatOddName(me.sportTree.oddTypes[odd.oi].ot, odd);
                odd.bgn = me.sportTree.markets[odd.bgi].bgn;

                groups[odd.bgi].odds[odd.oi] = odd;
            }

            const groupsFin = [];
            for (const bgi in groups)
            {
                if (groups[bgi] !== undefined)
                {
                    const group = groups[bgi];

                    const odds = [];
                    for (const oi in group.odds)
                    {
                        if (group.odds[oi] !== undefined)
                        {
                            odds.push(group.odds[oi]);
                        }
                    }

                    group.odds = odds;

                    groupsFin.push(group);
                }
            }

            me.groups = groupsFin;
        },
        async fetchMatchData()
        {
            const me = this;

            const data = await me.offerHandling.callOffer('/sport/getMatchesByIds',
                {
                    matchIds: me.selectedMatch,
                    includeNames: '1',
                    oddsresults: '1',
                });

            const match = data.data[0];

            match.utc = match.md;

            me.$emit('matchchange', match);
        },
    },
    watch:
    {
        matchesIn:
        {
            handler()
            {
                const me = this;
                me.generateGroups();
            },
            deep: true,
            immediate: true,
        },
        selectedMatch:
        {
            handler(oldValue, newValue)
            {
                const me = this;

                if (oldValue !== newValue)
                {
                    me.groups = [];
                    me.fetchMatchData();
                }
            },
        },
    },
    computed:
    {
        ...mapGetters({
            selectedMatch: 'selectedMatch',
            sportTree: 'sportTree',
            sportState: 'sportState',
            isMobile: 'isMobile',
            offerHandling: 'offerHandling',
        }),
        match()
        {
            const me = this;
            return me.matchesIn[me.selectedMatch];
        },
    },
};
</script>
